
let rootFontSize = document.getElementsByTagName('html')[0].style.fontSize
rootFontSize = parseFloat(rootFontSize)
let screenWidth = window.screen.width
let innerWidth = window.innerWidth
let width = screenWidth
if (innerWidth && innerWidth <= screenWidth) width = innerWidth
const ratio = width / 375

function fn (num) {
  return (num / rootFontSize) * ratio +'rem'
}

export default fn
